"use client";
import { useWatch } from "react-hook-form";
import { FormRow } from "@/components/form/FormRow";
import { IssueTypeField } from "../components/IssueTypeField";
import { FeedbackLocationField } from "../components/FeedbackLocationField";
import { FeedbackSeverityField } from "../components/FeedbackSeverityField";
import { FeedbackDescriptionField } from "../components/FeedbackDescriptionField";
import { useFeedbackFormMediator } from "../hooks/useFeedbackFormMediator";
import FormLayout from "@/components/form/FormLayout";
import { FormFileAttachment } from "@/components/form/FormFileAttachment";
import { Alert } from "@clarityos/ui/alert";
import { Lock } from "lucide-react";
import { FEEDBACK_ACCEPTED_FILE_TYPES } from "../constants";

export const feedbackFormId = "feedback-form";

interface FeedbackFormProps {
  onSubmit: VoidFunction;
}

export function FeedbackForm({ onSubmit }: FeedbackFormProps) {
  const { onIssueTypeChange } = useFeedbackFormMediator();
  const issueType = useWatch({ name: "issueType" });

  return (
    <form onSubmit={onSubmit} id={feedbackFormId}>
      <FormLayout>
        <FormRow>
          <IssueTypeField
            name="issueType"
            onAfterChange={onIssueTypeChange}
            testIdPrefix="feedback-issue-type"
          />
        </FormRow>
        <FormRow>
          <FeedbackLocationField name="location" />
          {issueType === "issue" && <FeedbackSeverityField name="severity" />}
        </FormRow>
        <FormRow>
          <FeedbackDescriptionField name="description" />
        </FormRow>
        <FormRow>
          <FormFileAttachment
            optional
            name="screenShot"
            label="screenshot"
            acceptedTypes={FEEDBACK_ACCEPTED_FILE_TYPES}
            data-testid="feedback-screenshot"
          />
        </FormRow>
        <FormRow>
          <Alert
            icon={Lock}
            severity="warning"
            message="Avoid including patient names and other PHI."
          />
        </FormRow>
      </FormLayout>
    </form>
  );
}
